/**
 * Order note text web component.
 * Listens for note:changed and toggles between "add" and "edit" order note text.
 */
class OrderNoteText extends HTMLElement {
  constructor() {
    super();
    this._noteChangedHandler = this._handleNoteChanged.bind(this);
  }

  connectedCallback() {
    this._orderNoteText = this.querySelector("[data-order-note-text]");
    if (!this._orderNoteText) return;

    document.addEventListener("note:changed", this._noteChangedHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("note:changed", this._noteChangedHandler);
  }

  _handleNoteChanged(event) {
    this._orderNoteText.textContent = event.detail
      ? window.themeVariables?.strings?.editOrderNote ?? "Edit order note"
      : window.themeVariables?.strings?.addOrderNote ?? "Add order note";
  }
}

customElements.define("order-note-text", OrderNoteText);
